export default "__VITE_PUBLIC_ASSET__1905f2ae__"